@if (isLoading()) {
  <div class="loader-wrapper">
    <img
      priority
      class="bike-loader"
      ngSrc="assets/icons/icon-bike.svg"
      alt="Papin bike loader..."
      height="589"
      width="656"
    />
    @if (text) {
      <app-spacer/>
      <h4>{{text}}</h4>
    }
  </div>
} @else {
  <ng-content></ng-content>
}

